import { VARIANTS } from '@components/ArtBoard/Node/constants'
import type React from 'react'

import { DEFAULT_PAGE_NAME } from '@/constants/defaultNames'
import type { TreeItemVariants } from '@/types'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

type Props = {
  name: string
  variant: TreeItemVariants
  isProjectNeutral?: boolean
  color: string
  customClassName?: string
}

export const Name: React.FC<Props> = ({
  name,
  variant,
  isProjectNeutral,
  color,
  customClassName,
}) => {
  const classNames = clsJoin(
    css.container,
    variant === VARIANTS.GHOST && css.ghost,
    variant === VARIANTS.FRAME && css.dashed,
    isProjectNeutral && css.neutral
  )

  return (
    <div className={classNames} style={{ color }}>
      <div className={clsJoin(css.name, customClassName)}>
        {name || DEFAULT_PAGE_NAME}
      </div>
    </div>
  )
}
